<template>
  <div>
    <v-card class="card-shadow border-radius-xl pa-6">
      <div class="pb-4">
        <h6 class="mb-1 text-typo text-h6 font-weight-bold">
          Informations client
        </h6>
      </div>
      <loading v-if="loading"></loading>
      <div v-else>
        <v-row>
          <v-col cols="6">
            <label class="text-xs text-typo font-weight-bolder ms-1">NOM</label>
            <v-text-field
              v-model="selectedClient.displayname"
              hide-details
              outlined
              color="rgba(0,0,0,.6)"
              light
              placeholder=""
              class="
                font-size-input
                placeholder-lighter
                border border-radius-md
                text-light-input
                mt-2
              "
            >
            </v-text-field>
          </v-col>
          <v-col cols="6">
            <label class="text-xs text-typo font-weight-bolder ms-1"
              >EMAIL ADMIN</label
            >
            <v-text-field
              v-model="selectedClient.adminemail"
              hide-details
              outlined
              color="rgba(0,0,0,.6)"
              light
              placeholder="admin@site.com"
              class="
                font-size-input
                placeholder-lighter
                border border-radius-md
                text-light-input
                mt-2
              "
            >
            </v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="6">
            <label class="text-xs text-typo font-weight-bolder ms-1"
              >COULEUR DE BANIÈRE</label
            >
            <v-text-field
              v-model="selectedClient.maincolor"
              hide-details
              outlined
              color="rgba(0,0,0,.6)"
              light
              placeholder="#ffffff"
              class="
                font-size-input
                placeholder-lighter
                border border-radius-md
                text-light-input
                mt-2
              "
            >
              <template v-slot:append>
                <v-fade-transition leave-absolute>
                  <div
                    class="color-display"
                    :style="`background: ${selectedClient.maincolor}`"
                  ></div>
                </v-fade-transition>
              </template>
            </v-text-field>
          </v-col>
          <v-col cols="6">
            <label class="text-xs text-typo font-weight-bolder ms-1"
              >LOGO</label
            >
            <v-text-field
              v-model="selectedClient.logo"
              hide-details
              outlined
              color="rgba(0,0,0,.6)"
              light
              placeholder="https://monsite.fr/logo.png"
              class="
                font-size-input
                placeholder-lighter
                border border-radius-md
                text-light-input
                mt-2
              "
            >
            </v-text-field>
          </v-col>
        </v-row>
        <v-row class="mt-2">
          <v-col cols="12">
            <label class="text-xs text-typo font-weight-bolder ms-1"
              >Charger un logo</label
            >
            <dropzone :multiple="false" v-model="fileSingle"></dropzone>
          </v-col>
        </v-row>
        <!-- SAVE FORM BTN -->
        <v-row class="dflex justify-end pa-4">
          <BtnBlue
            :btnTitle="$t('appButton.save')"
            @clicked="updateClientInfo"
          ></BtnBlue>
        </v-row>
      </div>
    </v-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import BtnBlue from "../common/BtnBlue.vue";
import Loading from "../common/Loading.vue";
import Dropzone from "../Dropzone.vue";

export default {
  name: "ClientInfo",

  components: {
    BtnBlue,
    Dropzone,
    Loading,
  },

  data() {
    return {
      loading: false,
      fileSingle: [],
    };
  },

  computed: {
    ...mapGetters(["selectedClient"]),
  },

  watch: {
    fileSingle(nVal) {
      if (nVal.length > 1) {
        this.fileSingle.shift();
      }
      this.$store.dispatch("update_image_url", nVal[0]);
    },
  },

  methods: {
    async updateClientInfo() {
      this.loading = true;
      await this.$store.dispatch(
        "update_logo",
        this.fileSingle[this.fileSingle.length - 1]
      );
      await this.$store.dispatch("update_selected_client");
      this.loading = false;
    },
  },
};
</script>

<style scoped>
.dz-message {
  z-index: 10 !important;
}

.color-display {
  width: 24px;
  height: 24px;
  border: 1px solid lightgrey;
  margin-top: 2px;
}
</style>
